import * as Types from '../../../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type OwnChatRoomOnUseMatchQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type OwnChatRoomOnUseMatchQuery = { __typename?: 'Query', ownChatRoom?: { __typename?: 'ChatRoom', id: string, status: Types.ChatRoomStatus, updatedAt: TimeString, hasUnreadMessage: boolean, hasUnrepliedMessage: boolean, userLatestReadMessageGUID?: string | null, match: { __typename?: 'Match', id: string, normalMessageChatReplyMatchSetting: { __typename?: 'NormalMessageChatReplyMatchSetting', disabledUntil?: TimeString | null } }, user?: { __typename?: 'User', id: string, birthYear?: number | null, nickname: string, gender: Types.UserGender, livingPrefecture?: Types.Prefecture | null, financialServicesAgent?: string | null, userRegistrationInflowSource?: string | null, address?: { __typename?: 'UserAddress', prefecture: string, city: string } | null, diagnosisResult?: { __typename?: 'DiagnosisResult', personality: { __typename?: 'Personality', type: Types.PersonalityType, title: string, description: string } } | null } | null, planner: { __typename?: 'Planner', id: string, name: string, avatar?: any | null, chatParticipant?: { __typename?: 'ChatParticipant', id: string } | null } } | null };

export type ColleagueChatRoomOnUseMatchQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ColleagueChatRoomOnUseMatchQuery = { __typename?: 'Query', colleagueChatRoom?: { __typename?: 'ChatRoom', id: string, status: Types.ChatRoomStatus, updatedAt: TimeString, hasUnreadMessage: boolean, hasUnrepliedMessage: boolean, userLatestReadMessageGUID?: string | null, match: { __typename?: 'Match', id: string, normalMessageChatReplyMatchSetting: { __typename?: 'NormalMessageChatReplyMatchSetting', disabledUntil?: TimeString | null } }, user?: { __typename?: 'User', id: string, birthYear?: number | null, nickname: string, gender: Types.UserGender, livingPrefecture?: Types.Prefecture | null, financialServicesAgent?: string | null, userRegistrationInflowSource?: string | null, address?: { __typename?: 'UserAddress', prefecture: string, city: string } | null, diagnosisResult?: { __typename?: 'DiagnosisResult', personality: { __typename?: 'Personality', type: Types.PersonalityType, title: string, description: string } } | null } | null, planner: { __typename?: 'Planner', id: string, name: string, avatar?: any | null, chatParticipant?: { __typename?: 'ChatParticipant', id: string } | null } } | null };

export type UseMatchChatRoomFragment = { __typename?: 'ChatRoom', id: string, status: Types.ChatRoomStatus, updatedAt: TimeString, hasUnreadMessage: boolean, hasUnrepliedMessage: boolean, userLatestReadMessageGUID?: string | null, match: { __typename?: 'Match', id: string, normalMessageChatReplyMatchSetting: { __typename?: 'NormalMessageChatReplyMatchSetting', disabledUntil?: TimeString | null } }, user?: { __typename?: 'User', id: string, birthYear?: number | null, nickname: string, gender: Types.UserGender, livingPrefecture?: Types.Prefecture | null, financialServicesAgent?: string | null, userRegistrationInflowSource?: string | null, address?: { __typename?: 'UserAddress', prefecture: string, city: string } | null, diagnosisResult?: { __typename?: 'DiagnosisResult', personality: { __typename?: 'Personality', type: Types.PersonalityType, title: string, description: string } } | null } | null, planner: { __typename?: 'Planner', id: string, name: string, avatar?: any | null, chatParticipant?: { __typename?: 'ChatParticipant', id: string } | null } };

export type ChatRoomMatchFragment = { __typename?: 'Match', id: string, normalMessageChatReplyMatchSetting: { __typename?: 'NormalMessageChatReplyMatchSetting', disabledUntil?: TimeString | null } };

export type MatchPlannerFragment = { __typename?: 'Planner', id: string, name: string, avatar?: any | null };

export type DiagnosisResultFragment = { __typename?: 'DiagnosisResult', personality: { __typename?: 'Personality', type: Types.PersonalityType, title: string, description: string } };

export type OwnChatRoomListUserMatchFragment = { __typename?: 'User', id: string, birthYear?: number | null, nickname: string, gender: Types.UserGender, livingPrefecture?: Types.Prefecture | null, financialServicesAgent?: string | null, userRegistrationInflowSource?: string | null, address?: { __typename?: 'UserAddress', prefecture: string, city: string } | null, diagnosisResult?: { __typename?: 'DiagnosisResult', personality: { __typename?: 'Personality', type: Types.PersonalityType, title: string, description: string } } | null };

export const ChatRoomMatchFragmentDoc = gql`
    fragment ChatRoomMatch on Match {
  id
  normalMessageChatReplyMatchSetting {
    disabledUntil
  }
}
    `;
export const DiagnosisResultFragmentDoc = gql`
    fragment DiagnosisResult on DiagnosisResult {
  personality {
    type
    title
    description
  }
}
    `;
export const OwnChatRoomListUserMatchFragmentDoc = gql`
    fragment OwnChatRoomListUserMatch on User {
  id
  birthYear
  nickname
  gender
  livingPrefecture
  address {
    prefecture
    city
  }
  diagnosisResult {
    ...DiagnosisResult
  }
  financialServicesAgent
  userRegistrationInflowSource
}
    ${DiagnosisResultFragmentDoc}`;
export const UseMatchChatRoomFragmentDoc = gql`
    fragment UseMatchChatRoom on ChatRoom {
  id
  status
  updatedAt
  hasUnreadMessage
  hasUnrepliedMessage
  userLatestReadMessageGUID
  match {
    ...ChatRoomMatch
  }
  user {
    ...OwnChatRoomListUserMatch
  }
  planner {
    id
    name
    avatar
    chatParticipant {
      id
    }
  }
}
    ${ChatRoomMatchFragmentDoc}
${OwnChatRoomListUserMatchFragmentDoc}`;
export const MatchPlannerFragmentDoc = gql`
    fragment MatchPlanner on Planner {
  id
  name
  avatar
}
    `;
export const OwnChatRoomOnUseMatchDocument = gql`
    query OwnChatRoomOnUseMatch($id: ID!) {
  ownChatRoom(id: $id) {
    ...UseMatchChatRoom
  }
}
    ${UseMatchChatRoomFragmentDoc}`;

/**
 * __useOwnChatRoomOnUseMatchQuery__
 *
 * To run a query within a Vue component, call `useOwnChatRoomOnUseMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnChatRoomOnUseMatchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOwnChatRoomOnUseMatchQuery({
 *   id: // value for 'id'
 * });
 */
export function useOwnChatRoomOnUseMatchQuery(variables: OwnChatRoomOnUseMatchQueryVariables | VueCompositionApi.Ref<OwnChatRoomOnUseMatchQueryVariables> | ReactiveFunction<OwnChatRoomOnUseMatchQueryVariables>, options: VueApolloComposable.UseQueryOptions<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables>(OwnChatRoomOnUseMatchDocument, variables, options);
}
export function useOwnChatRoomOnUseMatchLazyQuery(variables?: OwnChatRoomOnUseMatchQueryVariables | VueCompositionApi.Ref<OwnChatRoomOnUseMatchQueryVariables> | ReactiveFunction<OwnChatRoomOnUseMatchQueryVariables>, options: VueApolloComposable.UseQueryOptions<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables>(OwnChatRoomOnUseMatchDocument, variables, options);
}
export type OwnChatRoomOnUseMatchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OwnChatRoomOnUseMatchQuery, OwnChatRoomOnUseMatchQueryVariables>;
export const ColleagueChatRoomOnUseMatchDocument = gql`
    query ColleagueChatRoomOnUseMatch($id: ID!) {
  colleagueChatRoom(id: $id) {
    ...UseMatchChatRoom
  }
}
    ${UseMatchChatRoomFragmentDoc}`;

/**
 * __useColleagueChatRoomOnUseMatchQuery__
 *
 * To run a query within a Vue component, call `useColleagueChatRoomOnUseMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useColleagueChatRoomOnUseMatchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useColleagueChatRoomOnUseMatchQuery({
 *   id: // value for 'id'
 * });
 */
export function useColleagueChatRoomOnUseMatchQuery(variables: ColleagueChatRoomOnUseMatchQueryVariables | VueCompositionApi.Ref<ColleagueChatRoomOnUseMatchQueryVariables> | ReactiveFunction<ColleagueChatRoomOnUseMatchQueryVariables>, options: VueApolloComposable.UseQueryOptions<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables>(ColleagueChatRoomOnUseMatchDocument, variables, options);
}
export function useColleagueChatRoomOnUseMatchLazyQuery(variables?: ColleagueChatRoomOnUseMatchQueryVariables | VueCompositionApi.Ref<ColleagueChatRoomOnUseMatchQueryVariables> | ReactiveFunction<ColleagueChatRoomOnUseMatchQueryVariables>, options: VueApolloComposable.UseQueryOptions<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables>(ColleagueChatRoomOnUseMatchDocument, variables, options);
}
export type ColleagueChatRoomOnUseMatchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ColleagueChatRoomOnUseMatchQuery, ColleagueChatRoomOnUseMatchQueryVariables>;